import { Box, Paper, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import styles from './styles';
import FeedbackForm from './FeedbackForm';
import { useSelector } from 'react-redux';
import { getAllFeedbacks } from '../../../redux/slices/feedbacks/feedbacksSlice';
import AmplifySpinner from '../../LoadingSpinner/AmplifySpinner';
import Feeds from './Feeds';

const Feedbacks = ({ feedData }) => {
  const { isLoading } = useSelector(getAllFeedbacks);

  // Memoize the sorted feed data
  const sortedFeedData = useMemo(() =>
    [...feedData].sort((a, b) =>
      new Date(b.created_at) - new Date(a.created_at)
    ), [feedData]
  );

  return (
    <Paper
      elevation={3} // Slight shadow for depth
      square={false} // Rounded corners for a modern look
      component="section"
      sx={styles.fdPaper}
    >
      {/* Feedback Form section */}
      <FeedbackForm />

      {/* Show all feedbacks section */}
      {isLoading ? (
        <Box sx={styles.fdSpinner}>
          <AmplifySpinner isLoading={isLoading} />
        </Box>
      ) : (
        <Box sx={styles.fdSection}>
          {sortedFeedData?.length > 0 ? (
            sortedFeedData.map((feed) => (
              <Box key={feed.id} sx={styles.feedItem}> {/* Styled feed item */}
                <Feeds feed={feed} />
              </Box>
            ))
          ) : (
            <Typography
              component="span"
              variant="body1"
              sx={styles.emptyText}
            >
              No feedback available yet
            </Typography>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default Feedbacks;
